import { configBuilder } from "ccui-framework";

const Config = {
  premier: {
    variant: "website",
    sessionTracker: true,
    sessionDispatchType: "SHOW_SESSION_EXPIRE_WARNING",
    sessionUrl: "/v3/session",
    brand: "Premier",
    devMode: "production",
    x_cc_app: "yaz4e1t34",
    baseURL: "https://production-api.cardcash.com/",
    supportEmail: "customersuccess@cardcash.com",
    supportPhone: "1-800-227-4214",
    reduxLogger: false,
    socialMediaData: {
      facebook: "https://www.facebook.com/CardCash/",
      twitter: "https://twitter.com/CardCash",
      youtube: "https://www.youtube.com/channel/UCQde_0ikfr0uz7OeCvVQIgg",
      linkedin: "https://www.linkedin.com/company/cardcash-com/",
    },
    payPalClientId:
      "AdNrKxBub5b7vLSpYTmOtj0XchDNwSs_nR2SoX3JNS7iSoSnZoGcEC9hmeaL",
  },
  "test-premier": {
    devMode: "integration",
    ga: "",
    x_cc_app: "nE4/t1t3z",
    baseURL: "https://integration-api.cardcash.com/",
    reduxLogger: true,
    payPalClientId:
      "ATF4TKzdhNgCuKPF5oW9iYRw3YHQYo_DnrHBJA-uMdvIZRn-LEe6YpP5b7bKguBwCov14EhzWicyfi7m",
  },
  localhost: {
    devMode: "development",
    ga: "",
    x_cc_app: "nE4/t1t3z",
    baseURL: "https://integration-api.cardcash.com/",
    reduxLogger: true,
    payPalClientId:
      "ATF4TKzdhNgCuKPF5oW9iYRw3YHQYo_DnrHBJA-uMdvIZRn-LEe6YpP5b7bKguBwCov14EhzWicyfi7m",
  },
};

export const configModule = configBuilder("premier", Config);
